import React, { Component, createElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import b from 'b_';
import Accordion from '../Accordion/Accordion';
import FlagStore from '../../stores/FlagStore';
import './PagePreview.css';

const block = b.lock('PagePreview');

export default class PagePreview extends Component {
    static propTypes = {
        previewToggle: FlagStore.PropType.isRequired,
        headline: PropTypes.node.isRequired,
        pageComponent: PropTypes.func.isRequired,
        pageProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types,
        className: PropTypes.string,
    };

    render() {
        const { previewToggle, pageComponent, pageProps = {}, headline, className } = this.props;

        return <Accordion
            className={cn('PagePreview', className)}
            flagStore={previewToggle}
            labelClassName={block('PreviewLabel')}
            iconClassName={block('PreviewIcon')}
            contentClassName={block('PreviewContent')}
            label={<Fragment>
                <span className={block('PreviewLabelPrefix')}>Preview: </span>
                {headline}
            </Fragment>}
        >{createElement(pageComponent, pageProps)}</Accordion>;
    }
}
